import ArticleCard from '../../../components/ArticleCard/ArticleCard';
import { useArticles } from '../../../hooks/useArticles';
import { CardGTMData } from '../../../components/ArticleCard/CardUtils';
import { articleCardLocation } from '../../../utilities/gtm';
import { ARTICLE_CONTENT_TYPES } from '../types/types';
import { Box, Button, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router';
import { getRouterPathToContentIndex } from '../../../utilities/Links';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArticleMeta from '../../../types/ArticleMeta';
import ArticleCardSkeleton from '../../../components/ArticleCard/ArticleCardSkeleton';
import { DividerWithContent } from '../../../common/components/DividerWithContent';

interface RelatedArticlesSectionProps {
  primaryCategory: string;
}

const ARTICLE_LIMIT = 3;

function renderContent(articles: ArticleMeta[], isFetching: boolean) {
  if (isFetching) {
    return Array.from({ length: ARTICLE_LIMIT }).map((_, index) => (
      <ArticleCardSkeleton key={index} />
    ));
  }

  return articles.map((article, index) => (
    <ArticleCard
      key={article.id}
      meta={article}
      heading='h3'
      gtmData={
        {
          index,
          location: articleCardLocation.ARTICLE_FOOTER_RELATED,
        } as CardGTMData
      }
    />
  ));
}

export default function RelatedArticlesSection({
  primaryCategory,
}: RelatedArticlesSectionProps) {
  const { articles, isFetching, hasError } = useArticles({
    category: primaryCategory,
    contentType: ARTICLE_CONTENT_TYPES,
    limit: ARTICLE_LIMIT,
  });

  if (hasError) {
    return <Box>Artikkeleita ei saatu ladattua.</Box>;
  }

  if (!isFetching && (!articles || articles.length === 0)) {
    return <Box>Ei artikkeleita.</Box>;
  }

  return (
    <Box>
      <Stack direction='column' spacing={1}>
        {renderContent(articles, isFetching)}
      </Stack>
      <DividerWithContent>
        <Button
          component={RouterLink}
          to={getRouterPathToContentIndex(primaryCategory)}
          endIcon={<ArrowForwardIcon />}
          variant='outlined'
        >
          Lisää sisältöjä aiheesta
        </Button>
      </DividerWithContent>
    </Box>
  );
}
